import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ffd63a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "editorWrap" }
const _hoisted_2 = ["onInput", "onFocus", "onBlur"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "add-tool"
}
const _hoisted_6 = ["onMouseup"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "space" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 保存中 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#000000"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保存", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      header: "新規カテゴリ登録",
      show: _ctx.state.showModal
    }, {
      content: _withCtx(() => [
        _withDirectives(_createElementVNode("input", {
          class: "input-1",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.category) = $event))
        }, null, 512), [
          [_vModelText, _ctx.state.category]
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addCategory && _ctx.addCategory(...args)), ["stop","prevent"]))
        }, "登録")
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        tag: "ul",
        name: "list",
        class: "editor",
        onKeydown: _ctx.addInput
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.refreshWords, (word) => {
            return (_openBlock(), _createElementBlock("li", { key: word }, [
              _createElementVNode("div", {
                onInput: ($event: any) => (word.word = _ctx.trim($event.target.innerText)),
                onFocus: ($event: any) => {
            _ctx.state.currentInputIndex = word.id;
            _ctx.state.currentEditWord = word;
            word.edit = true;
          },
                onBlur: ($event: any) => {
            $event.target.innerText = _ctx.trim($event.target.innerText);
            _ctx.state.saveFlag = _ctx.check();
            word.edit = false;
          },
                onPaste: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.paste && _ctx.paste(...args))),
                contenteditable: "true",
                placeholder: "単語",
                class: _normalizeClass({
            dep: word.error.dep,
            cat: word.error.cat,
            current: _ctx.state.currentInputIndex == word.id,
            check: word.categories.length == 0 && word.word.length > 0,
            ok: word.categories.length && word.word.length > 0,
            edit: word.edit,
          })
              }, _hoisted_4, 42, _hoisted_2)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onKeydown"])
    ], 512),
    (_ctx.state.currentEditWord)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "scroll-wrap",
            onMousewheelPassive: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.mouseWheel && _ctx.mouseWheel(...args))),
            ref: "scroll"
          }, [
            _createElementVNode("ul", {
              class: _normalizeClass(["categories", {
          editable:
            _ctx.state.currentEditWord.word &&
            _ctx.state.currentEditWord.word.length >= 1,
        }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCategories, (cat) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: cat.id,
                  class: _normalizeClass({ pick: _ctx.pickAdd(cat.id) }),
                  onMousedown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.focusWord && _ctx.focusWord(...args))),
                  onMouseup: ($event: any) => (_ctx.toggleCategory(cat.id))
                }, _toDisplayString(cat.name), 43, _hoisted_6))
              }), 128)),
              _createElementVNode("li", {
                class: "add-category",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.showModal=true))
              }, "+"),
              _hoisted_7
            ], 2)
          ], 544),
          _createElementVNode("div", {
            class: _normalizeClass(["save", { check: _ctx.state.saveFlag, disable: _ctx.wordMutationLoading }]),
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveWords && _ctx.saveWords(...args)))
          }, [
            (_ctx.wordMutationLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_8
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_9,
                  _hoisted_10
                ], 64))
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}